import { z } from "zod";

// Order is append-only: `pillar` is a pg enum, and Postgres only supports
// adding values, never reordering. "Performance" (cwv), "Content Fitness" and
// "AI Reference" are the live score families; the
// other values are retained pg-enum members with no current metrics. Render
// order is a frontend concern, not this array's.
export const PILLARS = [
  "Performance",
  "Experience",
  "AI Readiness",
  "Discoverability",
  "Content Fitness",
  "AI Reference",
] as const;
export const PILLAR = {
  PERFORMANCE: "Performance",
  EXPERIENCE: "Experience",
  AI_READINESS: "AI Readiness",
  DISCOVERABILITY: "Discoverability",
  CONTENT_FITNESS: "Content Fitness",
  AI_REFERENCE: "AI Reference",
} as const satisfies Record<string, Pillar>;
export const PillarSchema = z.enum(PILLARS);
export type Pillar = z.infer<typeof PillarSchema>;

// MetricKey / MetricKeySchema are intentionally NOT defined here: the metric
// catalog (`../report/catalog`) is the single canonical source of metric keys
// and derives them from METRIC_CATALOG so a key cannot exist without a metric.

export const BLOCK_TYPES = [
  "note",
  "evidence",
  "recommendation",
  "rubric_item",
  "score_component",
  "qa",
] as const;
export const BLOCK_TYPE = {
  NOTE: "note",
  EVIDENCE: "evidence",
  RECOMMENDATION: "recommendation",
  RUBRIC_ITEM: "rubric_item",
  SCORE_COMPONENT: "score_component",
  QA: "qa",
} as const satisfies Record<string, BlockType>;
export const BlockTypeSchema = z.enum(BLOCK_TYPES);
export type BlockType = z.infer<typeof BlockTypeSchema>;

export const METRIC_SOURCES = ["static", "worker"] as const;
export const METRIC_SOURCE = {
  STATIC: "static",
  WORKER: "worker",
} as const satisfies Record<string, MetricSource>;
export const MetricSourceSchema = z.enum(METRIC_SOURCES);
export type MetricSource = z.infer<typeof MetricSourceSchema>;
